module.exports = __webpack_public_path__ + "static/media/second.7e39ff8e.jpeg";